import { useTranslation } from 'react-i18next';
import type { IBriefingListProps } from './IBriefingListProps';

/** «Опоненти» (прототип v4 ivOpps): на --surface2 — ім'я 600, належність дрібним, твердження червонуватим, «→ контраргумент» зеленим. */
export function BriefingOpponents({ items, onOpen }: IBriefingListProps) {
  const { t } = useTranslation();
  return (
    <section className="viz-card">
      <div className="viz-card__title">{t('recordPage.viz.briefing.opponents')}</div>
      {items.map((r) => (
        <button key={r.id} type="button" className="viz-item viz-item--alt" onClick={() => onOpen(r)}>
          <strong>{r.title || r.display}</strong>
          {r.values['affiliation'] ? <span className="viz-item__meta">{String(r.values['affiliation'])}</span> : null}
          {r.values['claims'] ? <span className="viz-item__bad">{String(r.values['claims'])}</span> : null}
          {r.values['counter'] ? <span className="viz-item__good">→ {String(r.values['counter'])}</span> : null}
        </button>
      ))}
    </section>
  );
}
